import React from 'react';
import DataList from './form/DataList';
import PropTypes from 'prop-types';

const limits = {
    night: {'pw': 35, 'igw': 40},
    day: {'pw': 45, 'igw': 50}
};

function renderResult(result) {
    if (result === 1) {
        return <span className='laermberechnung-result--high'>Der Richtwert wurde &uuml;berschritten.</span>
    } else if (result === -1) {
        return <span className='laermberechnung-result--low'>Der Richtwert wurde unterschritten.</span>
    } else if (result === 0) {
        return <span className='laermberechnung-result--low'>Der Richtwert ist ok.</span>
    }
}

function Result({id, title, valueType, sensitivity, lrDay, lrNight}) {
    const limitDay = limits.day[valueType] + sensitivity * 5;
    const resultDay = limitDay > lrDay ? -1 : limitDay < lrDay ? 1 : 0;
    const limitNight = limits.night[valueType] + sensitivity * 5;
    const resultNight = limitNight > lrNight ? -1 : limitNight < lrNight ? 1 : 0;

    return (
        <article id={id} className={'box'}>
            <h2>{title}</h2>
            <DataList data={[
                {key: 'Lr Tag', value: Math.round(lrDay)},
                {key: 'Lr Nacht', value: Math.round(lrNight)},
                {key: 'Beurteilung Tag', value: renderResult(resultDay)},
                {key: 'Beurteilung Nacht', value: renderResult(resultNight)},
            ]}/>
        </article>
    );
}

Result.propTypes = {
    id: PropTypes.string.isRequired,
    lrDay: PropTypes.number.isRequired,
    lrNight: PropTypes.number.isRequired,
    valueType: PropTypes.string.isRequired,
    sensitivity: PropTypes.number.isRequired,
    title: PropTypes.string
};

export default Result;